import axios from "axios";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API, withCredentials: true });

// Le GET pubbliche vengono ritentate (2 volte) su errori 5xx/rete: evita pagine vuote durante i riavvii del backend.
api.interceptors.response.use(undefined, async (err) => {
  const cfg = err?.config || {};
  const status = err?.response?.status;
  const ritentabile = (cfg.method || "get").toLowerCase() === "get" && (!err.response || status >= 500) && (cfg.__retry || 0) < 2;
  if (!ritentabile) throw err;
  cfg.__retry = (cfg.__retry || 0) + 1;
  await new Promise((r) => setTimeout(r, 700 * cfg.__retry));
  return api.request(cfg);
});

export function formatApiError(err, fallback = "Si è verificato un errore. Riprova.") {
  const detail = err?.response?.data?.detail;
  if (detail == null) return err?.message || fallback;
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export async function streamSSE(path, body, onDelta) {
  const res = await fetch(`${API}${path}`, {
    method: "POST",
    credentials: "include",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(body || {}),
  });
  if (!res.ok || !res.body) throw new Error(`Errore ${res.status}`);
  const reader = res.body.getReader();
  const decoder = new TextDecoder();
  let buffer = "";
  while (true) {
    const { value, done } = await reader.read();
    if (done) break;
    buffer += decoder.decode(value, { stream: true });
    const parts = buffer.split("\n\n");
    buffer = parts.pop();
    for (const part of parts) {
      const line = part.trim();
      if (!line.startsWith("data:")) continue;
      const evt = JSON.parse(line.slice(5).trim());
      if (evt.error) throw new Error(evt.error);
      if (evt.delta) onDelta(evt.delta);
    }
  }
}
